export default __webpack_public_path__ + "static/media/tdqn.0cbc9872.png";